import styled from 'styled-components';
import {hexToRGBA} from "../../utils/hexToRGBA";

const ButtonStyle = styled.button`
  width: ${(props) => (props.block ? '100%' : 'fit-content')};
  padding: ${(props) => props.$padding || '15px'};
  margin: ${(props) => props.$margin || '0'};
  background-color: ${(props) =>
    props.variant === 'primary' ? props.$themeColor : '#ffffff'};
  color: ${(props) =>
    props.variant === 'primary' ? '#ffffff' : props.$themeColor};
  border: ${(props) =>
    props.variant === 'primary'
      ? 'none'
      : `1px solid ${props.$themeColor}`};
  border-radius: 10px;
  font-family: ${(props) => props.$fontFamily || 'Arial, sans-serif'};
  font-size: ${(props) => props.$fontSize || '20px'};
  line-height: 1.2;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => hexToRGBA(props.$themeColor, 0.90)
  }
`;

export const Button = (props) => {
  const { variant = 'primary', block, ...others } = props;
  return (
    <ButtonStyle variant={variant} block={block} {...others}>
      {props.children}
    </ButtonStyle>
  );
};
